<template>
  <div>
    <div class="p-4">
      <!-- Bọc ngoài bằng toolbar-card chuẩn style Album -->
      <div class="toolbar-card">
        <attendance-filter-bar
            :date="date"
            :id-class="idClass"
            :id-grade="idGrade"
            :id-group="idGroup"
            :type="activeTab"
            :attendance-checked="attendanceChecked"
            :attendance-status="status"
            @change="handleFilterChange"
        />
        <div class="student-toolbar-divider"></div>
        <attendance-footer-action
            :dirty-count="dirtyIds.length"
            :is-saving="isSaving"
            @save="handleSave"
            @export-excel-by-date="handleExportExcelByDay"
            @export-excel="handleOpenDialogOptionsExportExcel"
            @constitutive="handleOpenConfigDialog"
        />
      </div>

      <div class="attendance-data-card">
        <div>
          <p class="card-title">Danh sách điểm danh học sinh</p>
          <p class="card-subtitle">Theo dõi thông tin điểm danh của học sinh</p>
        </div>
        <div class="card-header-tabs">
          <attendance-tab-switcher v-model="activeTab" @change="onChangeTab"/>
        </div>

        <div class="card-body-table">
          <attendance-table
              :items="items"
              :attendance-map="attendanceMap"
              :saving="isSaving"
              :loading="isLoading"
              @row-update="onRowUpdate"
              @update="handleView"
              @save-attendance="handleSaveAttendance"
              @selection-change="handleSelectionChange"
          />
        </div>
      </div>
    </div>

    <div>
      <attendance-update-action
          :dialog-visible="dialogVisible.update"
          :type="activeTab"
          @close="handleCloseDialogUpdate"
          ref="attendanceUpdateAction"
      />

      <attendance-options-export-excel
          :dialog-visible="dialogVisible.optionsExportExcel"
          :type="activeTab"
          :type-export="typeExportExcel"
          @close="handleCloseOptionsExportExcel"
          @export-excel="handleExportExcel"
          ref="AttendanceOptionsExportExcel"
      />

      <attendance-config-dialog :dialog-visible="dialogVisible.config" @dialog-close="handleCloseSystemConfigSchool"
                                ref="AttendanceConfigDialog"/>
    </div>
  </div>
</template>

<script>
import AttendanceFilterBar from '@/attendance_v3/components/AttendanceFilterBar.vue'
import AttendanceTabSwitcher from '@/attendance_v3/components/AttendanceTabSwitcher.vue'
import AttendanceTable from '@/attendance_v3/components/AttendanceTable.vue'
import AttendanceFooterAction from '@/attendance_v3/components/AttendanceFooterAction.vue'
import sampleData from '@/attendance_v3/mock/attendance-sample.json'
import AttendanceV3Service from "@/attendance_v3/services/AttendanceV3Service";
import AttendanceUpdateAction from "@/attendance_v3/components/dialog/AttendanceUpdateAction.vue";
import ExportAttendanceExcel from "@/attendance_v3/services/ExportAttendanceExcel";
import Vue from "vue";
import AttendanceOptionsExportExcel from "@/attendance_v3/components/dialog/AttendanceOptionsExportExcel.vue";
import AttendanceConfigDialog from "@/attendance_v3/components/dialog/AttendanceConfigDialog.vue";

export default {
  name: 'AttendancePage',
  components: {
    AttendanceConfigDialog,
    AttendanceOptionsExportExcel,
    AttendanceUpdateAction,
    AttendanceFilterBar,
    AttendanceTabSwitcher,
    AttendanceTable,
    AttendanceFooterAction,
  },
  data() {
    return {
      date: new Date().toLocaleDateString('en-CA'),
      idClass: null,
      idGrade: null,
      attendanceChecked: null,
      idGroup: null,
      pageSize: 25,
      currentPage: 1,
      limit: 25,
      offset: 0,
      total: 0,
      items: [],
      selectionMultiple: [],
      isLoading: false,
      isSaving: false,

      attendanceMap: {},
      dirtyIds: [],
      pendingBulkUpdates: [],
      activeTab: 'class',
      status: null,
      useMock: false,
      listSizePage: [25, 50, 100, 150, 200],
      dialogVisible: {
        update: false,
        optionsExportExcel: false,
        config: false,
      },
      typeExportExcel: ''
    }
  },
  methods: {
    handleFilterChange({date, idClass, idGrade, attendanceChecked, attendanceStatus, idGroup}) {
      this.date = date
      this.idClass = idClass
      this.idGrade = idGrade
      this.attendanceChecked = attendanceChecked
      this.status = attendanceStatus
      this.idGroup = idGroup
      this.currentPage = 1
      this.items = []
      this.attendanceMap = {}
      this.fetchList()
    },

    async fetchList() {
      this.isLoading = true
      try {
        this.limit = this.pageSize
        this.offset = this.currentPage - 1

        let data
        if (this.useMock) {
          data = sampleData
        } else {
          if (this.offset === 0) {
            this.items = [];
            this.attendanceMap = {};
            this.dirtyIds = [];
          }

          if (this.activeTab === 'class') {
            const res = await AttendanceV3Service.getAllAttendanceClass({
              idClass: this.idClass,
              idGrade: this.idGrade,
              date: this.date,
              limit: this.limit,
              offset: this.offset,
              status: this.status,
              marked: this.attendanceChecked,
            });
            data = res.data.data || res
          } else {
            const res = await AttendanceV3Service.getAllAttendanceGroup({
              idGroup: this.idGroup,
              date: this.date,
              limit: this.limit,
              offset: this.offset,
              status: this.status,
              marked: this.attendanceChecked,
            });
            data = res.data.data || res
          }
        }

        const incoming = data || []
        this.items = incoming

        incoming.forEach(it => {
          const id = it.idStudent
          if (!this.attendanceMap[id]) {
            this.$set(this.attendanceMap, id, {
              original: Object.assign({}, it),
              editing: Object.assign({}, it),
              dirty: false,
              saving: false,
              error: null,
            })
          } else {
            const state = this.attendanceMap[id]
            state.original = Object.assign({}, it)
            state.editing = Object.assign({}, state.editing || it)
          }
        })
      } catch (err) {
        this.$message.error('Lỗi khi tải danh sách')
      } finally {
        this.isLoading = false
      }
    },

    onRowUpdate({idStudent, editing, dirty}) {
      if (!this.attendanceMap[idStudent]) return
      this.attendanceMap[idStudent].editing = Object.assign({}, editing)
      this.attendanceMap[idStudent].dirty = dirty

      if (dirty) {
        if (!this.dirtyIds.includes(idStudent)) {
          this.dirtyIds.push(idStudent)
        }
      } else {
        const index = this.dirtyIds.indexOf(idStudent)
        if (index !== -1) {
          this.dirtyIds.splice(index, 1)
        }
      }
    },

    async handleSave() {
      if (this.isSaving || this.isLoading) return
      if (this.dirtyIds.length === 0) {
        this.$message.info('Không có thay đổi để lưu')
        return
      }

      const savedIds = [...this.dirtyIds]
      const formData = new FormData()
      savedIds.forEach((id, index) => {
        const editing = this.attendanceMap[id].editing

        formData.append(`updates[${index}].type`, `update-${this.activeTab}`)
        formData.append(`updates[${index}].idStudent`, id)
        if (this.activeTab === 'group') {
          formData.append(`updates[${index}].idGroup`, this.idGroup)
        } else {
          formData.append(`updates[${index}].currentIdClass`, this.idClass)
        }
        formData.append(`updates[${index}].attendanceDate`, this.date)
        formData.append(`updates[${index}].note`, '')
        formData.append(`updates[${index}].attendanceStatus`, editing.attendanceStatus || '')
        formData.append(`updates[${index}].arriveTime`, editing.arriveTime || '')
        formData.append(`updates[${index}].leaveTime`, editing.leaveTime || '')
        formData.append(`updates[${index}].methodArrive`, 'MANUAL')
        formData.append(`updates[${index}].methodLeave`, 'MANUAL')
        formData.append(`updates[${index}].breakfast`, editing.breakfast == null ? false : editing.breakfast)
        formData.append(`updates[${index}].mainMeal`, editing.mainMeal == null ? false : editing.mainMeal)
        formData.append(`updates[${index}].snack`, editing.snack == null ? false : editing.snack)
        formData.append(`updates[${index}].dinner`, editing.dinner == null ? false : editing.dinner)

        if (editing.pictureArrive) {
          formData.append(`updates[${index}].pictureArrive`, editing.pictureArrive)
        }
        if (editing.pictureLeave) {
          formData.append(`updates[${index}].pictureLeave`, editing.pictureLeave)
        }
      })

      this.isSaving = true
      return AttendanceV3Service.saveAttendanceFile({attendances: formData})
          .then(async response => {
            if (!this.checkSaveResult(response)) return
            this.markRowsSaved(savedIds)
            this.$message.success('Lưu điểm danh thành công')
            await this.fetchList()
          })
          .catch(err => {
            this.$message.error(err?.message || 'Lưu thất bại')
          })
          .finally(() => {
            this.isSaving = false
          })
    },

    handlePageChange(page) {
      this.currentPage = page
      this.fetchList()
    },

    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchList()
    },

    handleView({idStudent}) {
      this.dialogVisible.update = true
      this.$refs.attendanceUpdateAction.getDataArriveRowInitial({idStudent: idStudent, date: this.date, type: this.activeTab, idGroup: this.idGroup})
    },

    handleSaveAttendance({rows}) {
      if (this.isSaving || this.isLoading) return;
      rows = rows.filter(row => this.attendanceMap[row.idStudent]?.dirty);
      if (!rows.length) return;
      const formData = new FormData();
      rows.forEach((row, index) => {
        const editing = this.attendanceMap[row.idStudent].editing;
        const prefix = `updates[${index}].`;

        formData.append(`${prefix}type`, `update-${this.activeTab}`);
        formData.append(`${prefix}idStudent`, row.idStudent);
        if (this.activeTab === 'class') {
          formData.append(`${prefix}currentIdClass`, this.idClass);
        }
        formData.append(`${prefix}attendanceDate`, this.date);
        formData.append(`${prefix}note`, editing.note || "");

        if (editing.attendanceStatus) {
          formData.append(`${prefix}attendanceStatus`, editing.attendanceStatus);
        }

        if (editing.arriveTime) formData.append(`${prefix}arriveTime`, editing.arriveTime);
        if (editing.leaveTime) formData.append(`${prefix}leaveTime`, editing.leaveTime);

        formData.append(`${prefix}methodArrive`, "MANUAL");
        formData.append(`${prefix}methodLeave`, "MANUAL");
        formData.append(`${prefix}breakfast`, editing.breakfast ?? false);
        formData.append(`${prefix}mainMeal`, editing.mainMeal ?? false);
        formData.append(`${prefix}snack`, editing.snack ?? false);
        formData.append(`${prefix}dinner`, editing.dinner ?? false);

        if (this.activeTab === 'group') {
          formData.append(`${prefix}idGroup`, this.idGroup);
        }
      });

      this.isSaving = true;
      return AttendanceV3Service.saveAttendanceFile({attendances: formData}).then(async response => {
        if (!this.checkSaveResult(response)) return;
        this.markRowsSaved(rows.map(row => row.idStudent));
        this.$message.success('Lưu điểm danh thành công');
        await this.fetchList();
      }).catch(err => {
        this.$message.error(err?.response?.data?.message || err?.message || 'Lưu thất bại');
      }).finally(() => {
        this.isSaving = false;
      });
    },

    markRowsSaved(ids) {
      ids.forEach(id => {
        const state = this.attendanceMap[id];
        if (!state) return;
        state.original = Object.assign({}, state.editing);
        state.dirty = false;
      });
      this.dirtyIds = this.dirtyIds.filter(id => !ids.includes(id));
    },

    checkSaveResult(response) {
      const result = response?.data?.data;
      if (!result || result.errorCount > 0 || !(result.successCount > 0)) {
        const reason = result?.errors?.[0]?.reason;
        const message = result?.successCount > 0
            ? `Đã lưu ${result.successCount} học sinh, ${result.errorCount} học sinh lưu thất bại`
            : 'Lưu điểm danh thất bại';
        this.$message.error(reason ? `${message}: ${reason}` : message);
        return false;
      }
      return true;
    },

    handleSelectionChange(value) {
      this.selectionMultiple = value
    },

    handleCloseDialogUpdate() {
      this.dialogVisible.update = false
    },

    onChangeTab(tab) {
      this.activeTab = tab
      this.fetchList()
    },

    /**
     * Xuất Excel ngày
     * */
    handleExportExcelByDay() {
      const classId = this.idClass;
      const groupId = this.idGroup;
      const type = this.activeTab;
      const titleNotify = 'Xuất file Excel';

      const notify = this.$notify({
        title: titleNotify,
        message: `Đang tạo file Excel điểm danh ngày ${Vue.filter('formatDate')(this.date)}...`,
        iconClass: 'el-icon-loading',
        duration: 0
      });

      const apiCall = type === 'class'
          ? AttendanceV3Service.getAttendanceDayExportExcelClass({classId, date: this.date})
          : AttendanceV3Service.getAttendanceDayExportExcelGroup({groupId, date: this.date});

      apiCall
          .then((res) => {
            const data = res.data.data;
            const schoolName = data.schoolName;
            const targetName = type === 'class' ? data.className : data.groupName;
            const date = Vue.filter('formatDate')(data.date);
            const attendanceData = data.data;

            return ExportAttendanceExcel.exportAttendanceExcelByDay(schoolName, targetName, date, attendanceData, type);
          })
          .then(() => {
            this.$notify({
              title: titleNotify,
              message: "Xuất file điểm danh ngày thành công!",
              type: "success",
              duration: 3000
            });
          })
          .catch((err) => {
            this.$notify({
              title: titleNotify,
              message: "Xuất file điểm danh ngày thất bại!",
              type: "error",
              duration: 3000
            });
            console.debug("Có lỗi xảy ra:", err);
          })
          .finally(() => {
            notify.close();
          });
    },

    /**
     * Xuất Excel tháng
     * */
    handleExportExcelByMonth(data) {
      const classId = data.classId;
      const groupId = data.groupId;
      const type = data.type;
      const status = data.status;
      const rangeDate = data.rangeDate;
      const titleNotify = 'Xuất file Excel';

      const notify = this.$notify({
        title: titleNotify,
        message: `Đang tạo file Excel điểm danh tháng...`,
        iconClass: 'el-icon-loading',
        duration: 0
      })

      const apiCall = type === 'group'
          ? AttendanceV3Service.getAttendanceMonthExportExcelGroup({
            groupId: groupId,
            startDate: rangeDate[0],
            endDate: rangeDate[1],
            status: status
          })
          : AttendanceV3Service.getAttendanceMonthExportExcelClass({
            classId: type === 'class' ? classId : null,
            startDate: rangeDate[0],
            endDate: rangeDate[1],
            status: status
          });

      apiCall
          .then((res) => {
            const data = res.data.data;

            return ExportAttendanceExcel.exportAttendanceExcelByMonth(data, type);
          })
          .then(() => {
            this.$notify({
              title: titleNotify,
              message: "Xuất file điểm danh ngày thành công!",
              type: "success",
              duration: 3000
            });
            this.$refs.AttendanceOptionsExportExcel.closeDialog();
          })
          .catch((err) => {
            this.$notify({
              title: titleNotify,
              message: "Xuất file điểm danh ngày thất bại!",
              type: "error",
              duration: 3000
            });
            console.log("Có lỗi xảy ra:", err);
          })
          .finally(() => {
            notify.close();
          });
    },

    handleExportExcelGeneral(data) {
      const classId = data.classId;
      const groupId = data.groupId;
      const type = data.type;
      const status = data.status;
      const rangeDate = data.rangeDate;
      const titleNotify = 'Xuất file Excel';

      const notify = this.$notify({
        title: titleNotify,
        message: `Đang tạo file Excel tổng hợp ngày ${Vue.filter('formatDate')(Date.now())}...`,
        iconClass: 'el-icon-loading',
        duration: 0
      });

      const apiCall = type === 'group'
          ? AttendanceV3Service.getAttendanceSummaryExcelGroup({
            groupId: groupId,
            startDate: rangeDate[0],
            endDate: rangeDate[1],
            status: status
          })
          : AttendanceV3Service.getAttendanceSummaryExcelClass({
            classId: type === 'class' ? classId : null,
            startDate: rangeDate[0],
            endDate: rangeDate[1],
            status: status
          });

      apiCall
          .then((res) => {
            const data = res.data.data;

            return ExportAttendanceExcel.exportAttendanceExcelGeneral(data, type);
          })
          .then(() => {
            this.$notify({
              title: titleNotify,
              message: "Xuất file điểm danh ngày thành công!",
              type: "success",
              duration: 3000
            });
            this.$refs.AttendanceOptionsExportExcel.closeDialog();
          })
          .catch((err) => {
            this.$notify({
              title: titleNotify,
              message: "Xuất file điểm danh ngày thất bại!",
              type: "error",
              duration: 3000
            });
            console.log("Có lỗi xảy ra:", err);
          })
          .finally(() => {
            notify.close();
          });
    },

    handleExportExcelGeneralDate(data) {
      const classId = data.classId;
      const groupId = data.groupId;
      const type = data.type;
      const status = data.status;
      const rangeDate = data.rangeDate;
      const titleNotify = 'Xuất file Excel';

      const notify = this.$notify({
        title: titleNotify,
        message: `Đang tạo file Excel chi tiết tháng ${Vue.filter('formatDate')(Date.now())}...`,
        iconClass: 'el-icon-loading',
        duration: 0
      });

      const apiCall = type === 'group'
          ? AttendanceV3Service.getAttendanceMonthlyDetailExcelGroup({
            groupId: groupId,
            startDate: rangeDate[0],
            endDate: rangeDate[1],
            status: status
          })
          : AttendanceV3Service.getAttendanceMonthlyDetailExcelClass({
            classId: classId,
            startDate: rangeDate[0],
            endDate: rangeDate[1],
            status: status
          });

      apiCall
          .then((res) => {
            const data = res.data.data;
            return ExportAttendanceExcel.exportAttendanceExcelDetailed(data, type);
          })
          .then(() => {
            this.$notify({
              title: titleNotify,
              message: "Xuất file điểm danh ngày thành công!",
              type: "success",
              duration: 3000
            });
            this.$refs.AttendanceOptionsExportExcel.closeDialog();
          })
          .catch((err) => {
            this.$notify({
              title: titleNotify,
              message: "Xuất file điểm danh ngày thất bại!",
              type: "error",
              duration: 3000
            });
            console.log("Có lỗi xảy ra:", err);
          })
          .finally(() => {
            notify.close();
          });
    },

    handleOpenDialogOptionsExportExcel(command) {
      this.typeExportExcel = command;
      this.dialogVisible.optionsExportExcel = true;
    },

    handleCloseOptionsExportExcel() {
      this.typeExportExcel = '';
      this.dialogVisible.optionsExportExcel = false;
    },

    handleExportExcel(data) {
      switch (this.typeExportExcel) {
        case 'by-month':
          this.handleExportExcelByMonth(data)
          break;
        case 'general':
          this.handleExportExcelGeneral(data)
          break;
        case 'general-date':
          this.handleExportExcelGeneralDate(data)
          break;
      }
    },
    handleOpenConfigDialog() {
      this.dialogVisible.config = true;
      this.$refs.AttendanceConfigDialog.getDataInitial();
    },
    handleCloseSystemConfigSchool() {
      this.dialogVisible.config = false;
    },
  }
}
</script>

<style scoped>
.p-4 {
  padding: 1rem;
}

.toolbar-card {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 16px 20px;
  background: #ffffff;
  border: 1px solid #e8edf4;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(31, 45, 61, 0.06);
  margin-bottom: 16px;
}

/* ─── STYLE CHO KHỐI CARD DỮ LIỆU TABS + TABLE ─────────────────────── */
.attendance-data-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 16px;
  margin-top: 16px; /* Khoảng cách thông thoáng với Filter Bar phía trên */
  margin-bottom: 16px; /* Khoảng cách với Footer Action phía dưới */
  border: 1px solid #f1f5f9;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04); /* Đổ bóng nhẹ sang trọng */
}

/* Đẩy nút Tab điều hướng về bên phải trong Header Card */
.card-header-tabs {
  display: flex;
  justify-content: flex-end;
}

.card-body-table {
  width: 100%;
}

.card-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.card-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

.student-toolbar-divider {
  width: 1px;
  height: 24px;
  background: #e2e8f0;
  margin: 0 20px;
  flex-shrink: 0;
}
</style>